/** A referential list: no tenant, no parameter. */
class FetchSubjectFieldNatures {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchSubjectFieldNatures;
